module.exports = __webpack_public_path__ + "static/logo-6fda798789797febd70456b858450e5b.svg";